export const universities = [
    "University of Aberdeen",
    "Abertay University",
    "Aberystwyth University",
    "ACM (The Academy of Contemporary Music)",
    "Academy of Live Technology",
    "Activate Learning",
    "Amity University [IN] London",
    "Anglia Ruskin University",
    "Health Sciences University (formerly AECC University College)",
    "Arts University Bournemouth",
    "Arts University Plymouth",
    "ARU London",
    "University Centre Askham Bryan",
    "Associated Studios Performing Arts Academy",
    "Aston University, Birmingham",
    "Bangor University",
    "Barnet and Southgate College",
    "Barnfield College, Luton",
    "Bath College",
    "Bath Spa University",
    "University of Bath",
    "Bedford College Group",
    "University of Bedfordshire",
    "BIMM University",
    "Birkbeck, University of London",
    "Birmingham City University",
    "BMet (Birmingham Metropolitan College)",
    "South and City College Birmingham",
    "University College Birmingham",
    "University of Birmingham",
    "University Centre Bishop Burton",
    "Bishop Grosseteste University",
    "Blackburn College",
    "Blackpool and the Fylde College",
    "University of Bolton",
    "Boston College",
    "Bournemouth and Poole College",
    "Bournemouth University",
    "BPP University",
    "Bradford College",
    "University of Bradford",
    "Bridgend College",
    "University Centre Somerset - Bridgwater & Taunton College",
    "Trinity Laban",
    "Brighton and Sussex Medical School",
    "University of Brighton",
    "City of Bristol College",
    "University of Bristol",
    "British Academy of Jewellery",
    "ESO and BCOM - part of BCNO Group",
    "London South East Colleges (Bromley College)",
    "Brunel University of London",
    "University of Buckingham",
    "Buckinghamshire New University",
    "Burnley College",
    "Bury College",
    "University Centre Calderdale College",
    "Cambridge Regional College",
    "Cambridge School of Visual and Performing Arts",
    "University of Cambridge",
    "Canterbury Christ Church University",
    "EKC Group",
    "Cardiff Metropolitan University",
    "Cardiff University",
    "Central Film School London",
    "University of Central Lancashire",
    "University of the Arts London",
    "University of Chester",
    "Chesterfield College",
    "Chichester College Group (inc Brinsbury, Chichester, Crawley, Northbrook & Worthing Colleges)",
    "University of Chichester",
    "Christ the Redeemer College",
    "City College Norwich (incorporating Easton College)",
    "City (City St George's, University of London)",
    "The Northern School of Art",
    "Cliff College",
    "Open University",
    "Middlesbrough College",
    "Grwp Llandrillo Menai",
    "Collective Acting Studio",
    "College of Agriculture, Food and Rural Enterprise",
    "College of Esports",
    "Cornwall College",
    "Courtauld Institute of Art, University of London",
    "Coventry University",
    "Coventry College",
    "Craven College",
    "Croydon University Centre",
    "University of Cumbria",
    "David Game College - Higher Education Centre",
    "dBs Institute",
    "De Montfort University",
    "Derby College",
    "University of Derby",
    "Dudley College",
    "University of Dundee",
    "Durham University",
    "New College Durham",
    "University of East London",
    "East Riding College",
    "Orbital South Colleges University Centre",
    "Edge Hill University",
    "Edinburgh Napier University",
    "The University of Edinburgh",
    "Escape Studios",
    "ESCP Business School",
    "University of Essex",
    "European School of Economics",
    "Exeter College",
    "University of Exeter",
    "Falmouth University",
    "University Centre Farnborough",
    "Fashion Retail Academy",
    "Furness College",
    "Gateshead College",
    "Glasgow Caledonian University",
    "City of Glasgow College",
    "Glasgow School of Art",
    "University of Glasgow",
    "Gloucestershire College",
    "University of Gloucestershire",
    "Goldsmiths, University of London",
    "Gower College Swansea",
    "University of Greenwich",
    "University Centre Grimsby",
    "Halesowen College",
    "Harlow College",
    "Harper Adams University",
    "Harper and Keele Veterinary School",
    "New City College (incorporating Havering College)",
    "Haybridge School Centred Initial Teacher Training",
    "Hereford College of Arts",
    "Herefordshire, Ludlow & North Shropshire College",
    "Heriot-Watt University",
    "Hertford Regional College",
    "University of Hertfordshire",
    "University of the Highlands and Islands (UHI)",
    "Holy Cross Sixth Form College and University Centre",
    "Hopwood Hall College",
    "University of Huddersfield",
    "Hugh Baird College",
    "Hull College",
    "University of Hull",
    "Hult International Business School",
    "University of Reading",
    "Imperial College London",
    "Institute of Contemporary Music Performance",
    "International Business College Manchester",
    "International College of Musical Theatre (ICMT)",
    "Islamic College for Advanced Studies",
    "Istituto Marangoni London",
    "JCA | London Fashion Academy",
    "Keele University",
    "Kent and Medway Medical School",
    "University of Kent",
    "King's College London, University of London",
    "Kingston University",
    "KLC School of Design",
    "Lancaster University",
    "LCCM",
    "Leeds Beckett University",
    "University Centre Leeds, Leeds City College",
    "Leeds Arts University",
    "Leeds Conservatoire",
    "Leeds Trinity University",
    "University of Leeds",
    "Leicester College",
    "University of Leicester",
    "LIBF",
    "Lincoln College University Centre",
    "University of Lincoln",
    "City of Liverpool College University Centre",
    "Liverpool Hope University",
    "Liverpool Institute for Performing Arts",
    "Liverpool John Moores University",
    "University of Liverpool",
    "LMA",
    "London College of Business Studies",
    "London College of Contemporary Arts",
    "London College",
    "London Film Academy",
    "London Interdisciplinary School (LIS)",
    "London Metropolitan University",
    "Bloomsbury Institute London",
    "London School of Economics and Political Science, University of London",
    "London School of Management Education",
    "London School of Theology",
    "London South Bank University",
    "Vogue College of Fashion",
    "Loughborough College",
    "Loughborough University",
    "UCEN Manchester",
    "Manchester Metropolitan University",
    "University of Manchester",
    "McTimoney College of Chiropractic",
    "Medway School of Pharmacy",
    "MetFilm",
    "Middlesex University",
    "Morley College London",
    "Moulton College",
    "University Centre Myerscough",
    "Nazarene Theological College",
    "Nelson and Colne College Group",
    "NESCOT",
    "New College Swindon University Centre",
    "New Model Institute for Technology and Engineering (NMITE)",
    "Newcastle College University Centre",
    "Newcastle University",
    "Newham College of Further Education",
    "Birmingham Newman University",
    "Norland",
    "North Hertfordshire College",
    "North Kent College",
    "DN Colleges Group",
    "North Warwickshire and South Leicestershire College",
    "University of Northampton",
    "Northumbria University, Newcastle",
    "Norwich University of the Arts",
    "Nottingham Trent University",
    "Nottingham College",
    "University of Nottingham",
    "NPTC Group",
    "Northeastern University London",
    "Oaklands College",
    "University Campus Oldham",
    "Other",
    "Oxford Brookes University",
    "University of Oxford",
    "Warwickshire College and University Centre",
    "Peter Symonds' College",
    "University Centre Peterborough",
    "Petroc",
    "Plumpton College",
    "University of Plymouth",
    "City College Plymouth",
    "pointblank Music School",
    "University of Portsmouth",
    "Queen Margaret University, Edinburgh",
    "Queen Mary University of London",
    "Queen's University Belfast",
    "Ravensbourne University London",
    "Richmond American University London",
    "Robert Gordon University",
    "University of Roehampton",
    "Rose Bruford College",
    "Royal Academy of Dance",
    "Royal Agricultural University",
    "Royal Birmingham Conservatoire",
    "Royal Central School of Speech and Drama, University of London",
    "Royal College of Music",
    "Royal Conservatoire of Scotland",
    "Royal Holloway, University of London",
    "Royal Northern College of Music",
    "Royal Veterinary College, University of London",
    "Royal Welsh College of Music and Drama",
    "SAE Institute",
    "University of St Andrews",
    "St George's (City St George's, University of London)",
    "Plymouth Marjon University",
    "University Centre at Salford City College",
    "University of Salford",
    "Regent's University London",
    "Sheffield College",
    "Sheffield Hallam University",
    "University of Sheffield",
    "Shrewsbury Colleges Group",
    "Coleg Sir Gar",
    "SOAS University of London",
    "Solihull College & University Centre",
    "Futureworks",
    "University Centre South Devon",
    "Havant and South Downs College",
    "University Centre South Essex",
    "SGS (South Gloucestershire and Stroud College)",
    "South Thames College Group (inc Carshalton, South Thames and Kingston College)",
    "University of South Wales",
    "Southampton, Solent University",
    "University of Southampton",
    "SP Jain London School of Management",
    "University Centre Sparsholt",
    "Spurgeon's College",
    "SRUC Scotland's Rural College",
    "University Centre St Helens",
    "University of Stirling",
    "Trafford & Stockport College Group",
    "Stranmillis University College",
    "University of Strathclyde",
    "City of Sunderland College",
    "University of Sunderland",
    "University of Surrey",
    "East Sussex College",
    "University of Sussex",
    "Swansea University",
    "Tameside College",
    "Teesside University",
    "The Engineering & Design Institute London",
    "University Centre Truro and Penwith",
    "St Mary's University, Twickenham",
    "Two Mile Ash ITTP (partnered with Chiltern Training Group)",
    "Tyne Coast College",
    "UCL (University College London)",
    "University of East Anglia UEA",
    "Ulster University",
    "Universal Centre of Sport",
    "University Academy 92 (UA92)",
    "Barnsley College University Centre",
    "University Centre Colchester at Colchester Institute",
    "Hartpury University",
    "University Centre Reaseheath",
    "University Centre Rotherham",
    "University Centre Weston",
    "University College of Estate Management",
    "University for the Creative Arts",
    "University of Central Lancashire London",
    "The University of Law",
    "University of London Institute in Paris",
    "University of Staffordshire",
    "University of Suffolk",
    "University of Wales Trinity Saint David",
    "Bristol, UWE",
    "Wrexham University",
    "Harrow, Richmond & Uxbridge College",
    "University Centre at the Heart of Yorkshire Education Group (inc Wakefield College & Selby College)",
    "Walsall College",
    "University of Warwick",
    "UCFB",
    "University Centre West Anglia",
    "West Dean College",
    "West Herts College",
    "University of West London",
    "University of the West of Scotland",
    "West Suffolk College",
    "Capital City College",
    "United Colleges Group",
    "University of Westminster, London",
    "Weymouth and Kingston Maurward College",
    "Royal Academy of Music, University of London",
    "Wigan and Leigh College",
    "Wiltshire College and University Centre",
    "University of Winchester",
    "Wirral Metropolitan College",
    "University of Wolverhampton",
    "University of Worcester",
    "Heart of Worcestershire College",
    "Xenophon College London - On hold",
    "Yeovil College University Centre",
    "York College University Centre",
    "York St John University",
    "University of York",
    "Other"
  ];
  